import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import Form from "components/common/Form";
import { useRef } from "react";
import { formTypes } from "utils/Types";

interface Props {
  openEditPlan: boolean;
  setOpenEditPlan: any;
  isTemplateType?: boolean;
}

function Edit(props: Props) {
  const formRef = useRef<any>(null);
  const { openEditPlan, setOpenEditPlan, isTemplateType = false } = props;

  const formSubmit = () => {
    formRef?.current?.submitEditForm();
  };

  const handleCloseEditDialog = () => {
    setOpenEditPlan(false);
  };

  return (
    <DialogFormation
      title="Edit plan"
      openDialog={openEditPlan}
      handleClose={handleCloseEditDialog}
      actionConfig={
        <div className="modal-config-wrapper">
          <Button variant="secondary" label="Cancel" onClick={handleCloseEditDialog} />
          <Button variant="primary" label="Save" onClick={formSubmit} />
        </div>
      }
    >
      <Form
        isTemplateType={isTemplateType}
        ref={formRef}
        handleCloseDialog={handleCloseEditDialog}
        formType={formTypes.EditPlan}
      />
    </DialogFormation>
  );
}

export default Edit;
